import { useState, useCallback } from 'react'
import FormDrawer from '../../../../shared/components/drawers/FormDrawer'
import DeploymentsSection from './DeploymentsSection'
import DeploymentCreateForm from './DeploymentCreateForm'

function ProjectDeploymentsTab({
  deployments,
  nodes,
  loading,
  createDeployment,
  onSuccess
}) {
  const [drawerOpen, setDrawerOpen] = useState(false)

  const handleOpenDrawer = useCallback(() => {
    setDrawerOpen(true)
  }, [])

  const handleCloseDrawer = useCallback(() => {
    setDrawerOpen(false)
  }, [])

  const handleSuccess = useCallback(() => {
    setDrawerOpen(false)
    if (onSuccess) {
      onSuccess()
    }
  }, [onSuccess])

  return (
    <>
      <DeploymentsSection
        titleId="dockerProjects.sections.deployments"
        deployments={deployments}
        nodes={nodes}
        onCreateClick={handleOpenDrawer}
      />

      <FormDrawer
        open={drawerOpen}
        onClose={handleCloseDrawer}
        titleId="deployments.create.title"
      >
        <DeploymentCreateForm
          nodes={nodes}
          createDeployment={createDeployment}
          onSuccess={handleSuccess}
          onCancel={handleCloseDrawer}
        />
      </FormDrawer>
    </>
  )
}

export default ProjectDeploymentsTab
